import { render, staticRenderFns } from "./AppdbTools.vue?vue&type=template&id=0bf47216&scoped=true"
import script from "./AppdbTools.vue?vue&type=script&lang=js"
export * from "./AppdbTools.vue?vue&type=script&lang=js"
import style0 from "./AppdbTools.vue?vue&type=style&index=0&id=0bf47216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf47216",
  null
  
)

export default component.exports